import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import DonationPrepareApp from './DonationPrepareApp.vue';
import SubscriptionApp from './SubscriptionApp.vue';
import MySingleTrailsApp from './MySingleTrailsApp.vue';
import PasswordForgottenApp from './PasswordForgottenApp.vue';
import PasswordResetApp from './PasswordResetApp.vue';

if (document.querySelector('#vue-app')) {
  createApp(App).use(router).use(store).mount('#vue-app');
}
if (document.querySelector('#donationprepareapp')) {
  createApp(DonationPrepareApp).use(router).use(store).mount('#donationprepareapp');
}
if (document.querySelector('#subscriptionapp')) {
  createApp(SubscriptionApp).use(router).use(store).mount('#subscriptionapp');
}
if (document.querySelector('#mysingletrailsapp')) {
  createApp(MySingleTrailsApp).use(store).mount('#mysingletrailsapp');
}
if (document.querySelector('#vue-passwordforgotten')) {
  createApp(PasswordForgottenApp).use(store).mount('#vue-passwordforgotten');
}
if (document.querySelector('#vue-passwordreset')) {
  createApp(PasswordResetApp).use(store).mount('#vue-passwordreset');
}
